import { Role } from '@shared/enums/role.enum';

export const DEFAULT_ROUTES_BY_ROLE: Record<Role, string> = {
  Admin: '/dashboard/contractors',
  FullContractor: '/dashboard/company-information/add',
  LimitedAdmin: '/dashboard/contractors',
};
